var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupedTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.25 7.625H1.75C1.41848 7.625 1.10054 7.7567 0.866116 7.99112C0.631696 8.22554 0.5 8.54348 0.5 8.875V12C0.5 12.3315 0.631696 12.6495 0.866116 12.8839C1.10054 13.1183 1.41848 13.25 1.75 13.25H14.25C14.5815 13.25 14.8995 13.1183 15.1339 12.8839C15.3683 12.6495 15.5 12.3315 15.5 12V8.875C15.5 8.54348 15.3683 8.22554 15.1339 7.99112C14.8995 7.7567 14.5815 7.625 14.25 7.625ZM14.25 12H1.75V8.875H14.25V12ZM14.25 0.75H1.75C1.41848 0.75 1.10054 0.881696 0.866116 1.11612C0.631696 1.35054 0.5 1.66848 0.5 2V5.125C0.5 5.45652 0.631696 5.77446 0.866116 6.00888C1.10054 6.2433 1.41848 6.375 1.75 6.375H14.25C14.5815 6.375 14.8995 6.2433 15.1339 6.00888C15.3683 5.77446 15.5 5.45652 15.5 5.125V2C15.5 1.66848 15.3683 1.35054 15.1339 1.11612C14.8995 0.881696 14.5815 0.75 14.25 0.75ZM14.25 5.125H1.75V2H14.25V5.125Z",
    fill: "#7F8080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupedTable);
export default __webpack_public_path__ + "static/media/GroupedTable.1b454039.svg";
export { ForwardRef as ReactComponent };